import { RefObject } from "react";
import {
  ChatMessage,
  ChatMessageArtifact,
  ChatMessageMetadata,
} from "@store/messages.store";
import { Messages } from "./Messages";

type Props = {
  currentThread: string;
  isReady: boolean;
  isSendingMessage: boolean;
  isStreamAwaiting: boolean;
  hasPendingBotMessage: boolean;
  isReconnecting: boolean;
  isReceivingMessageResponse: boolean;
  isLoadingMessages: boolean;
  messages: ChatMessage[];
  getMessageMetadata: (
    threadId: string,
    messageId: string,
  ) => ChatMessageMetadata | undefined;
  handleThreadSuggestionClick: (suggestion: { prompt: string }) => void;
  handleArtifactClick: (artifact: ChatMessageArtifact) => void;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  isFetchingNextPage?: boolean;
  messagesContainerRef: RefObject<HTMLDivElement>;
  hasMoreAutoInteractions?: boolean;
};

export const ChatThreadView = ({
  currentThread,
  isReady,
  isSendingMessage,
  isStreamAwaiting,
  hasPendingBotMessage,
  isReconnecting,
  isReceivingMessageResponse,
  isLoadingMessages,
  messages,
  getMessageMetadata,
  handleThreadSuggestionClick,
  handleArtifactClick,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  messagesContainerRef,
  hasMoreAutoInteractions,
}: Props) => (
  <Messages
    key={`messages-${currentThread}`}
    isReady={isReady}
    isSendingMessage={
      isSendingMessage || isStreamAwaiting || hasPendingBotMessage
    }
    isReconnecting={isReconnecting}
    isReceivingMessageResponse={isReceivingMessageResponse}
    currentThread={currentThread}
    isLoadingMessages={isLoadingMessages}
    messages={messages}
    getMessageMetadata={getMessageMetadata}
    handleThreadSuggestionClick={handleThreadSuggestionClick}
    handleArtifactClick={handleArtifactClick}
    hasNextPage={hasNextPage}
    fetchNextPage={fetchNextPage}
    isFetchingNextPage={isFetchingNextPage}
    messagesContainerRef={messagesContainerRef}
    hasMoreAutoInteractions={hasMoreAutoInteractions}
  />
);
